import React, { useEffect, useState } from 'react';
import s from './ProgressLine.styles';

const ProgressLine = ({
    visualParts = [
        {
            percentage: "0%",
            color: "white",
            label: "default"
        }
    ]
}) => {
    const [widths, setWidths] = useState(
        visualParts.map(() => {
            return 0;
        })
    );
    useEffect(() => {
        setWidths(
            visualParts.map(item => {
                return item.percentage;
            })
        );
    }, [visualParts]);

    return (
        <>
            <s.ProgressVisualFull>
                {visualParts.map((item, index) => {
                    return (
                        <s.ProgressVisualPart
                            key={index}
                            style={{
                                width: widths[index],
                                // setting the actual color of bar part
                                backgroundColor: item.color
                            }}
                            className="progressVisualPart"
                        />
                    );
                })}
            </s.ProgressVisualFull>
            <s.ProgressLegend>
                {visualParts.map((item, index) => {
                    return (
                        <s.ProgressLegendWrapper key={index}>
                            <s.ProgressLegendPart
                                className="progressLegendPart"
                                style={{
                                    backgroundColor: item.color
                                }}
                            />
                            <s.ProgressLegendLabelWrapper>
                                <s.ProgressLegendLabel>{item.label}</s.ProgressLegendLabel>
                                <s.ProgressLegendPercentage>{item.percentage}</s.ProgressLegendPercentage>
                            </s.ProgressLegendLabelWrapper>
                        </s.ProgressLegendWrapper>
                    );
                })}
            </s.ProgressLegend>
        </>
    );
};

export default ProgressLine;
